import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {IAppConfig} from '../models/interfaces/app-config.interface';
import {environment} from "../../../environments/environment";
import {BehaviorSubject} from "rxjs";
import {ToolsService} from "../../../../../shared/src/lib/services/tools.service";

@Injectable()
export class AppConfigService {

  private config = new BehaviorSubject<IAppConfig | undefined>(undefined);
  public config$ = this.config.asObservable()

  constructor(public toolsService: ToolsService) {
  }

  load() {
    const jsonFile = `assets/config/config.${environment.name}.json`;
    return new Promise<void>((resolve, reject) => {
      this.toolsService.getData(jsonFile).subscribe((response) => {
        this.config.next(response as any);
        resolve();
      });
    });
  }

  getConfig() {
    const val = this.config.getValue();
    if (!val) {
      throw new Error('Error with configurations');
    }
    return val
  }
}
